module.exports = __webpack_public_path__ + "img/abtus-line-1.f6a37bc2.svg";